import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { initSentryFromEnvironment } from './app/utilities/monitoring/sentry/sentry-init';
import { captureSentryException } from './app/utilities/monitoring/sentry/sentry-capture.util';
import '@mux/mux-player';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HeaderInterceptorService } from './app/utilities/services/Interceptors/header-interceptor.service';

// ✅ Set default theme before app bootstraps
const storedTheme = localStorage.getItem('theme');
if (!storedTheme || storedTheme === 'light') {
  localStorage.setItem('theme', 'light'); // Optional: persist
}

initSentryFromEnvironment('website');

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...(appConfig.providers || []),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptorService,
      multi: true,
    }
  ]
}).catch((err) => {
  console.error(err);
  captureSentryException(err);
});